import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface SectionHeadingProps {
  icon?: string;
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
  action?: ReactNode;
  as?: "h2" | "h3";
}

export default function SectionHeading({
  icon,
  title,
  subtitle,
  moreTo,
  moreLabel = "查看更多",
  action,
  as = "h2",
}: SectionHeadingProps) {
  const Tag = as;
  return (
    <div className="flex flex-wrap items-end justify-between gap-3 mb-5">
      <div className="flex items-start gap-3">
        {icon && (
          <span className="w-9 h-9 rounded-lg bg-primary-100 text-primary-600 flex items-center justify-center shrink-0">
            <i className={`${icon} text-lg`} />
          </span>
        )}
        <div>
          <Tag className="font-heading font-bold text-lg text-foreground-950 flex items-center gap-2">
            {title}
          </Tag>
          {subtitle && <p className="text-sm text-foreground-500 mt-1">{subtitle}</p>}
        </div>
      </div>
      {action}
      {!action && moreTo && (
        <Link
          to={moreTo}
          className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer flex items-center gap-1 whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}